import React, { useState } from 'react'
import './list.scss'
import Pagination from "react-js-pagination";

const List = ({ price, index, winners }) => {
    const copyPrice = ["Primer", "Segundo", "Tercer"];
    const [numItemsPagination] = useState(10)
    const [pagination, setPagination] = useState(1)

    const handlePageChange = (pageNumber) => {
        setPagination(pageNumber);
    }
    return (

        <div className="f-winner-list-price">
            <img alt={price.description} src={price.image} />
            <div className="f-winner-list-price-list">
                <div className="f-winner-list-price-list-title">
                    <p >{copyPrice[index]} premio</p>
                    {winners.length > numItemsPagination && <p>{(numItemsPagination * (pagination - 1)) + 1} - {numItemsPagination * pagination} de {winners.length}</p>}
                </div>
                <div className="f-winner-list-price-list-items">
                    {winners.map((winner, index) => {
                        if (index < numItemsPagination * pagination && numItemsPagination * (pagination - 1) <= index) {
                            return (
                                <div key={index} className="f-winner-list-price-list-winner">
                                    <p className="f-winner-list-price-list-winner-name">{winner.name}</p>
                                    <p className="f-winner-list-price-list-winner-email">{winner.email}</p>
                                </div>
                            )
                        }else{
                            return null
                        }

                    }
                    )
                    }
                    {winners.length === 0 && <p className="f-winner-list-price-list-winner-name">No se encontraron ganadoras</p>}
                </div>
           
                {winners.length > numItemsPagination && <div className="f-winner-list-price-list-pagination">
                    <Pagination
                        activePage={pagination}
                        itemsCountPerPage={numItemsPagination}
                        totalItemsCount={winners.length}
                        pageRangeDisplayed={5}
                        onChange={handlePageChange}
                    />
                </div>}
            </div>
        </div>

    )
}

export default List
